<script>
import * as R from 'ramda'

export default {
  props: {
    metrics: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      metricInfos: [
        '<b>STAAR Percentage at Masters Grade Level Standard</b> - The percentage of tests that met the Masters Grade Level performance standard.This indicator was part of determining the score for Index 3.',
        '<b>STAAR Percentage Met or Exceeded Progress</b> - The percentage of tests that met or exceeded the STAAR or ELL progress measure expectations.',
        '<b>STAAR Percentage Exceeded Progress</b> - The percentage of tests that exceeded the progress measure expectations.',
      ],
    }
  },
  computed: {
    selected() {
      let selectOption = R.find(R.propEq('disabled', false), this.metrics)
      return selectOption ? selectOption.label : ''
    },
  },
}
</script>

<template>
  <v-list class="single-filter">
    <v-subheader class="reports-filters">Categories
      <v-menu
        :close-on-content-click="false"
        :nudge-width="300"
        :max-width="300"
        offset-x
        class="info-btn"
      >
        <!-- <v-btn
          slot="activator"
          icon
          class="mt-0 mb-0 mr-0">
          <v-icon>info</v-icon>
        </v-btn> -->
        <v-card>
          <v-card-text
            v-for="(item,index) in metricInfos"
            :key="index"
            v-html="item"/>
        </v-card>
      </v-menu>
    </v-subheader>
    <v-list-tile-content>
      <v-radio-group
        v-model="selected"
        class="mb-3"
        column>
        <v-radio
          v-for="(option,index) in metrics"
          :key="index"
          :label="option.label"
          :value="option.label"
          :disabled="option.disabled"
          color="grey"
          class="custom-radio"
        />
      </v-radio-group>
      <span class="category-tip">To compare categories, click "Edit Chart Options" and select multiple categories.</span>
    </v-list-tile-content>
  </v-list>
</template>

<style scoped>
.reports-filters {
  font-weight: bolder;
  font-size: 16px;
  font-size: 1.25rem;
  color: #707070;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  height: fit-content;
  margin-bottom: 5px;
  justify-content: space-between;
}
.reports-filters >>> .btn__content {
  color: #253e90;
}
.reports-filters >>> .btn__content::before {
  color: #0390c4;
  opacity: 0.5;
}
.info-btn :hover {
  cursor: pointer;
}
.single-filter {
  position: relative;
}
.single-filter >>> .input-group {
  padding: 0px;
}
.single-filter >>> .input-group__details {
  display: none;
}
.single-filter >>> .list__tile {
  padding: 0px;
}
.single-filter >>> .list__tile--avatar {
  height: 20px;
}
.single-filter >>> .custom-radio {
  display: flex;
  flex-flow: row-reverse;
  height: auto;
}
.single-filter >>> .list__tile__content {
  display: block;
}
.single-filter >>> .custom-radio > label {
  padding-top: 2px;
  font-size: 14px;
  font-size: 0.875rem;
  white-space: normal;
  line-height: 1.4rem;
  height: auto;
  min-width: unset;
  max-width: 100%;
  position: static;
  left: unset;
  flex: 1 1 auto;
}
.single-filter >>> .custom-radio > .input-group__input {
  flex: 0 0 30px;
}
.category-tip {
  font-size: 12px;
  font-size: 0.875rem;
}
/* .single-filter >>> .custom-radio > label:hover,
.radio-group [aria-checked='true'] {
  font-weight: bold;
  color: black;
} */
</style>
